import { render, staticRenderFns } from "./ExamTitlesNotesCreate.vue?vue&type=template&id=2ffab3c4"
import script from "./ExamTitlesNotesCreate.vue?vue&type=script&lang=js"
export * from "./ExamTitlesNotesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports